import { useState } from "react";
import { Copy } from "lucide-react";

const CopyButton = ({ text }: { text: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="flex items-center text-sm text-blue-500 hover:text-blue-700"
    >
      {copied ? "Copied!" : <Copy className="mr-1 h-4 w-4" />}
    </button>
  );
};

export default CopyButton;
